<nav>
  <vnm-storefront-brand [storefront]="currentUser.storefront$ | async"></vnm-storefront-brand>
  <a
    *ngIf="storefront?.can?.createOrder"
    (click)="productCatalogService.presentCatalog()"
    class="menu-item cursor-pointer"
  >
    <fa-icon icon="shopping-bag" [fixedWidth]="true"></fa-icon>
    <span translate>sidebar.product-catalog</span>
  </a>
  <p-panelMenu [model]="model | mit: 'sidebar' | async"></p-panelMenu>
  <a *ngIf="user?.can?.provideSupport" [routerLink]="['support']" class="menu-item">
    <fa-icon icon="life-ring" [fixedWidth]="true"></fa-icon>
    <span translate>sidebar.provide-support</span>
  </a>
  <p-menu id="userMenu" [model]="userMenus.sidebarMenu$ | async | mit: 'user-menu' | async"></p-menu>
</nav>
<a class="sidebar-modal" (click)="onCloseSidebar($event)"></a>
